import React, { Component } from 'react'
import HomeSection from './HomeContainer.js';

export default class home extends Component {
    render() {
        return (
            <div>
                <HomeSection/>
            </div>
        )
    }
}
